(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('session-type', {
                parent: 'entity',
                url: '/session-type',
                data: {
                    authorities: [],
                    pageTitle: 'SessionTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/session-type/list/session-type.html',
                        controller: 'SessionTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Session Type'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SESSION_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SESSION_TYPE, access);
                }]
            });
    }
})();
